<app-navbar class="home" [home_address]="session_info?.last_routes.new_home || '/'"></app-navbar>

<div class="landing-wrapper">
  <div class="container">

    <section class="landing-contents">

      <div class="row">
        <div class="col-md-7 pt-5">
          <br>
          <br>
          <h1>Pop-up Forms</h1>
          <p>
            With over 200 million responses collected, easily create user-friendly pop-up forms for any of your dynamic
            QR codes with just a few clicks.
          </p>
          <a class="btn btn-secondary-light" [routerLink]="coreService.isLoggedIn() ? '/user/popups' : '/auth/signup'">
            Get started
            <i class="bi bi-arrow-right ms-2"></i>
          </a>
        </div>
        <div class="col-md-5 pop-up-form-demo text-end pt-5">
          <video src="assets/pop-up-forms/pop-up-form-demo.mp4#t=0.5" preload="metadata" autoplay loop></video>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center pt-5">
          <h1>Attach pop-up forms to your QR codes to easily turn anonymous QR scanners into qualified leads for your
            company.</h1>
          <p>You can now collect performance statistics, fully design your pop-up forms with your brand's colours and
            company logo, schedule when it shows and modify the data it collects whenever you want.</p>
          <a class="btn btn-secondary-light" [routerLink]="coreService.isLoggedIn() ? '/user/popups' : '/auth/signup'">
            <i class="bi bi-back me-2"></i>
            Get started</a>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 pop-up-to-increase-conversion">
          <video src="assets/pop-up-forms/pop-up-to-increase-conversion.mp4#t=0.5" preload="metadata" autoplay
            loop></video>
        </div>
        <div class="col-md-6">
          <h1>Increase conversions from your page visitors with pop-up forms.</h1>
          <p>Choose from a variety of pop-up styles, such as lightboxes, slide-in boxes, and big side-bars, and control
            how and when they display to your QR scanners. </p>
          <p>These pop-ups can be customised and are compatible with all of your dynamic QR pages.</p>
        </div>
      </div>

      <div class="row design-pop-up-wrapper">
        <div class="col-md-6">
          <h1>Design & Schedule Pop-up display</h1>
          <p>Configure when pop-up shows, specify delay in seconds, specific dates, hours of the day and specific
            countries.</p>
        </div>
        <div class="col-md-6 pop-up-form-design-schedule">
          <video src="assets/pop-up-forms/pop-up-form-design-schedule.mp4#t=0.5" preload="metadata" autoplay
            loop></video>
        </div>
      </div>
      <br>
      <br>
      <br>
      <div class="row mt-5">
        <div class="col-md-6 pop-up-form-analytics-demo">
          <video src="assets/pop-up-forms/pop-up-form-analytics-demo.mp4#t=0.5" preload="metadata" autoplay
            loop></video>
        </div>
        <div class="col-md-6">
          <h1>Useful analytics</h1>
          <p>Get a detailed view of your Pop-up performance with data that helps you optimise performance - number of
            views, opt-ins, opt-outs etc.</p>
        </div>
      </div>

      <div class="row design-pop-up-wrapper mb-5">
        <div class="col-md-12 pt-5 text-center">
          <small class="text-muted">GETTING STARTED</small>
          <h1 class="squeeze-sm">Don't let the opportunity to increase online traffic pass you by.
          </h1>
          <p>The free features of BrandQrCodes have restrictions.</p>
          <a class="btn btn-secondary" routerLink="/pricing">
            <i class="bi bi-back me-2"></i>
            See pricing</a>
        </div>
      </div>

      <app-core-faqs-landing-page [category]="faq_category"></app-core-faqs-landing-page>

    </section>
  </div>
</div>

<app-footer></app-footer>